import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getExchangeData } from 'src/redux/thunks'
import { getCompleteExchangeEntityData } from 'src/redux/selectors'
import { MainLayout } from 'src/layouts'
import { Breadcrumbs } from 'src/components/Breadcrumbs'
import {
  TopInfoBlock,
  GeneralInfoBlock,
  MarketInfoBlock,
  ExchangeHeaderFees,
  ExchangeAbout,
} from './components'
import useWidth from 'src/hooks/useWidth'
import dynamic from 'next/dynamic'
import styles from './styles.module.scss'
import { ENTITY } from 'src/consts'
import ErrorPage from 'src/pages/ErrorPage'
import { intl } from 'src/i18n'

const MarketsExchange = dynamic(
  () =>
    import(
      'src/pages/CoinDetails/components/MarketsTab/MarketsExchangeContainer'
    ),
  {
    ssr: false,
  }
)

const ExchangeDetails = () => {
  const exchangesBreadrumbs = [
    { breadcrumb: 'Exchanges', href: '/exchange/table' },
  ]
  const exchangeData = useSelector(getCompleteExchangeEntityData)
  const errorPage = !exchangeData
  const { isMobile } = useWidth()
  const dispatch = useDispatch()

  useEffect(() => {
    if (!errorPage) {
      const intervalData = setInterval(async () => {
        await dispatch(
          getExchangeData({ slug: exchangeData?.slug, isRefresh: true })
        )
      }, 10000)

      return () => clearInterval(intervalData)
    }
  }, [dispatch, exchangeData?.slug, errorPage])

  if (errorPage)
    return (
      <ErrorPage
        code={404}
        description='Sorry, the page you are looking for has not been found. Try returning to the Homepage.'
        title='Page not found'
      />
    )

  const title = intl.t('exchangeDetails.seo.title', {
    exchangeDataName: exchangeData.name,
    exchangeDataText:
      exchangeData.name.length > 25 ? `charts` : `charts and market trading`,
  })

  const uri = `/exchange/${exchangeData?.slug}`

  return (
    <MainLayout title={title} uri={uri} scrollToTop>
      <Breadcrumbs items={exchangesBreadrumbs} lastItem={exchangeData.name} />
      <div className={styles.contentWrapper}>
        <TopInfoBlock data={exchangeData} />
        <div className={styles.bottomPart}>
          <GeneralInfoBlock data={exchangeData} />
          <MarketInfoBlock data={exchangeData} />
          {isMobile && <ExchangeHeaderFees data={exchangeData} />}
        </div>
        <ExchangeAbout data={exchangeData} />
        <MarketsExchange
          isMobile={isMobile}
          entity={ENTITY.EXCHANGE}
          slug={exchangeData.slug}
          symbol={exchangeData.symbol.toLowerCase()}
          name='Active'
          // exchangeLink={exchangeLink}
        />
      </div>
    </MainLayout>
  )
}

export default ExchangeDetails
